import { colors } from '@tidb-community/ui';
import Label from '~/components/label';
import styled from 'styled-components';

export const OriginLabel = styled(Label).attrs({ $color: colors.T6 })``;
export const RepostLabel = styled(Label).attrs({ $color: colors.T5 })``;
